import { getOccupancyLevel } from "./get-occupancy-level";

document.addEventListener("turbolinks:load", function() {
  // include this if the server has too big workload we can disable the feature
  if (document.head.querySelector('meta[name="disable-occupancy-level"]')) {
    return;
  }

  const miniCalendar = document.querySelectorAll(".mini-calendar");
  const currentMiniCalendar = miniCalendar[0];
  const calendar = document.querySelector("#calendar");

  if (miniCalendar.length === 0) {
    return;
  }

  let occupancyLevelData = [];

  function resetCalendarColors() {
    occupancyLevelData = []
    miniCalendar.forEach(calendar => {
      calendar
        .querySelectorAll("tbody td")
        .forEach(element => (element.dataset.occupancyLevel = ""));
    });
  }
  function updateCalendarDay(date) {
    miniCalendar.forEach(calendar => {
      calendar.querySelectorAll(".day-" + date.date).forEach(element => {
        if (date.events_duration_minutes === 0) {
          element.dataset.occupancyLevel = "";
          return;
        }

        element.dataset.occupancyLevel = getOccupancyLevel(date.percentage);
      });
    });
  }

  const updateOccupancyLevel = _.debounce(function(
    startDate,
    endDate,
    professionalId
  ) {
    occupancyLevelData = [];
    if (!Number(professionalId)) {
      resetCalendarColors()
      return;
    }

    fetch(
      "/events/occupancy-level?occupancy_level[professional_id]=" +
        encodeURI(professionalId) +
        "&occupancy_level[start_date]=" +
        encodeURI(startDate) +
        "&occupancy_level[end_date]=" +
        encodeURI(endDate)
    )
      .then(response => response.json())
      .then(data =>
        data.data.map(function(date) {
          occupancyLevelData.push(date);
          updateCalendarDay(date);
        })
      );
  },
  500);

  function updateOccupancyLevelPerProfessional(professionalId) {
    var firstDayCurrentMonth = $(
      currentMiniCalendar.querySelector(
        "tbody td:not(.ui-datepicker-other-month)"
      )
    );
    var month = String(Number(firstDayCurrentMonth.dataset.month) + 1);
    var date = firstDayCurrentMonth.dataset.year + "-" + month + "-" + "01";

    updateOccupancyLevel(
      moment(date)
        .startOf("month")
        .format("YYYY-MM-DD"),
      moment(date)
        .endOf("month")
        .format("YYYY-MM-DD"),
      professionalId
    );
  }

  // sometimes the mini calendar is update and loses the classes that color the day
  const updateOccupancyLevelFromCache = _.debounce(() => {
    occupancyLevelData.map(function(date) {
      if (date.events_duration_minutes === 0) {
        return;
      }

      miniCalendar.forEach(calendar => {
        calendar
          .querySelectorAll(".day-" + date.date)
          .forEach(
            element =>
              (element.dataset.occupancyLevel = getOccupancyLevel(
                date.percentage
              ))
          );
      });
    });
  }, 10);

  document.addEventListener(
    "occupancyLevel/updateFromCache",
    function(event) {
      updateOccupancyLevelFromCache();
    },
    false
  );

  document.addEventListener(
    "occupancyLevel/reset",
    function(event) {
      resetCalendarColors();
    },
    false
  );

  document.addEventListener(
    "occupancyLevel/refresh",
    function(event) {
      const professionalId = event.detail?.professional_id
        ? event.detail?.professional_id
        : calendar.dataset.selectedProfessionalId;

      if (professionalId == 0) {
        return resetCalendarColors();
      }

      const date = window.miniCalendarCurrentMonth
        ? new Date(
            window.miniCalendarCurrentMonth.year,
            window.miniCalendarCurrentMonth.month - 1,
            1
          )
        : new Date();

      updateOccupancyLevel(
        moment(date)
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment(date)
          .endOf("month")
          .format("YYYY-MM-DD"),
        professionalId
      );
    },
    false
  );

  document.addEventListener(
    "occupancyLevel/update",
    function(event) {
      updateOccupancyLevel(
        event.detail.start_date,
        event.detail.end_date,
        event.detail.professional_id
      );
    },
    false
  );

  document.addEventListener(
    "occupancyLevel/event",
    function(event) {
      const eventData = event.detail.event;
      const startDate = moment(eventData.start ? eventData.start : eventData.starts_at);
      const endDate = moment(eventData.end ? eventData.end : eventData.ends_at);
      const dateString = startDate.format("YYYY-MM-DD");
      const dateIndex = occupancyLevelData.findIndex(date => {
        return date.date === dateString;
      });

      if (dateIndex === -1) {
        return;
      }

      const duration =
        eventData.type === "Compromise"
          ? moment.duration(endDate.diff(startDate)).asMinutes()
          : eventData.duration;

      const occupancyDate = occupancyLevelData[dateIndex];

      if (event.detail.type === "create") {
        occupancyDate.events_duration_minutes += duration;
      }

      if (event.detail.type === "destroy") {
        occupancyDate.events_duration_minutes -= duration;
      }

      occupancyDate.percentage =
        (occupancyDate.events_duration_minutes /
          occupancyDate.working_duration_minutes) *
        100;

      updateCalendarDay(occupancyDate);
      occupancyLevelData[dateIndex] = occupancyDate;
    },
    false
  );

  updateOccupancyLevel(
    moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DD"),
    moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DD"),
    calendar.dataset.selectedProfessionalId
  );
});
